import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

export default function AdminHome({ token, me }) {
  if (!token) return <Navigate to="/auth" replace />;
  if (me == null) return <div className="mx-auto max-w-7xl px-4 py-6"><div>Loading…</div></div>;
  if (me && !me.is_admin) return <div className="mx-auto max-w-7xl px-4 py-6"><h2>Access denied</h2><Link to="/">Return to Dashboard</Link></div>;
  return (
    <div className="mx-auto max-w-7xl px-4 py-6 text-left">
      <h1 className="mb-2 text-2xl font-semibold tracking-tight">Admin Dashboard</h1>
      <p className="mb-4 text-sm text-muted-foreground">Connected to: <code>{API_BASE}</code></p>
      <div className="mb-4">
        <Link to="/">← Back to Dashboard</Link>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {/*
        Payments UI consolidated into Users & Entries
        */}
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Users & Entries</CardTitle>
            <CardDescription>Browse users and their entries; open/close entry creation.</CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/admin/users">Open Users & Entries →</Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Weeks & Locks</CardTitle>
            <CardDescription>Manage current week and lock times.</CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/admin/config">Open Weeks & Locks →</Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Broadcast</CardTitle>
            <CardDescription>Send an announcement to users.</CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/admin/broadcast">Open Broadcast →</Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
